/*eslint-disable */

import axios from 'axios';
import { bus } from '@/main';
import paperReqFieldsUpdateForCitation from './paper-required-fields-update-for-citation-popup/';
import root from '@/_helpers/roots';

let citationGetApiUrl = root.citationGetApiUrl.link;

export default {
  name: 'paper-citation-popup',
  components: {
    'field-req-citation' : paperReqFieldsUpdateForCitation
  },
  props: ['paperId'],
  data () {
    return {
      citationData:null,
      paperMetadata:null
    }
  },
  computed: {

  },
  mounted () {
    axios.get(citationGetApiUrl + '?paper_id=' + this.paperId).then((res) => {
      this.citationData = res.data.data.results
    })
  },
  methods: {
    closeCreatePaperpilePopup(){
      bus.$emit('paperCitationPopupStateBus', false);
      document.body.classList.remove('body_right_scroll_remove')
    },
  }
}